<!-- <app-project-deadline [deadline]="deadline"></app-project-deadline> -->
<!-- <app-project-collaborators [collaborators]="project.collaborators.length" [project]="project"></app-project-collaborators> -->
<app-project-description [description]="description" [project]="project"></app-project-description>
